import React, { Component } from 'react';
import { connect } from 'react-redux';

import ExchangeListHandlers from 'exchange/containers/ExchangeListHandlers';
import ExchangeRowContainer from 'exchange/containers/ExchangeRowContainer';
import * as Exchange from 'exchange/components';

import { getVisibleExchange, getPagination, getFilters, getIsLoading } from 'exchange/selectors';
import { getPermissions, getCompany } from 'auth/selectors';

class ExchangeListContainer extends Component {
  renderRows = () =>
    this.props.exchange.map((exchange) => (
      <ExchangeRowContainer key={exchange.id} exchange={exchange} />
    ));

  render = () => (
    <ExchangeListHandlers
      render={({
        handleOrderChange,
        handlePageChange,
        handleLimitChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
      }) => (
        <Exchange.ListView
          count={this.props.exchange.length}
          filters={this.props.filters}
          company={this.props.company}
          isLoading={this.props.isLoading}
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.renderRows()}
        </Exchange.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  permissions: getPermissions(state),
  exchange: getVisibleExchange(state),
  pagination: getPagination(state),
  filters: getFilters(state),
  isLoading: getIsLoading(state),
});

export default connect(mapStateToProps, null)(ExchangeListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/containers/ExchangeListContainer.js